import { useEffect } from 'react'

import { OrganizationFeature } from '@features/settings/enums/organizationFeature'

interface UseCloseWhenFecImportFeatureDisabledParams {
  hasFeature: (feature: OrganizationFeature) => boolean
  isLoading: boolean
  onClose: () => void
}

export const useCloseWhenFecImportFeatureDisabled = ({
  hasFeature,
  isLoading,
  onClose,
}: UseCloseWhenFecImportFeatureDisabledParams): void => {
  useEffect(() => {
    if (isLoading || hasFeature(OrganizationFeature.FecFileImport)) {
      return
    }

    onClose()
  }, [hasFeature, isLoading, onClose])
}
